import { z } from "zod";
import { publicEndpoint } from "~/lib/api/builder";

export const login = publicEndpoint.mutation(
    (json) => ({
        json,
        method: "POST",
        url: "auth/login",
    }),
    {
        input: z.object({
            email: z.string(),
            password: z.string(),
            slug: z.string(),
        }),
        output: z.object({
            access_token: z.string(),
            refresh_token: z.string(),
            refresh_token_ttl: z.string(),
        }),
    },
);
